var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIllustrationBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#598BFF",
    opacity: 0.1,
    cx: 23.5,
    cy: 23.5,
    r: 23.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.694 21.637A5.477 5.477 0 0010 25.6c0 1.5.602 2.906 1.694 3.963a.84.84 0 001.164-.001.784.784 0 00-.003-1.132 3.916 3.916 0 010-5.66.784.784 0 00.003-1.132.84.84 0 00-1.164-.001zM36.308 21.637a.84.84 0 00-1.165.001.784.784 0 000 1.132 3.915 3.915 0 010 5.66.784.784 0 000 1.132.84.84 0 001.165.001A5.488 5.488 0 0038 25.6a5.488 5.488 0 00-1.692-3.963z",
    fill: "#36F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.182 26.166a.783.783 0 010-1.132.784.784 0 000-1.13.84.84 0 00-1.164 0 2.351 2.351 0 000 3.393.84.84 0 001.164 0 .784.784 0 000-1.131zM32.818 23.903a.784.784 0 000 1.131.783.783 0 010 1.132.784.784 0 000 1.13.84.84 0 001.164 0 2.351 2.351 0 000-3.393.84.84 0 00-1.164 0zM31.412 30.4v-8c0-3.294-2.287-6.159-5.543-6.963-1.17-.32-2.586-.315-3.719-.004-3.274.808-5.562 3.673-5.562 6.967v8c0 .441-.37.8-.823.8a.812.812 0 00-.824.8c0 .442.369.8.824.8h16.47a.812.812 0 00.824-.8c0-.442-.369-.8-.824-.8a.813.813 0 01-.823-.8zM24 12c-1.2 0-2.2.835-2.423 1.938.644-.172 1.247-.34 2.418-.34 1.035 0 1.683.142 2.427.335C26.198 12.833 25.198 12 24 12z",
    fill: "#36F"
  }))));
}

export default SvgIllustrationBell;